import { css } from 'styled-components';

import { Colour } from '@xemplo/style-constants';

import { HeaderIconMode } from './common-header-icon.types';

export const IconContainerCommonStyles = css`
  display: flex;
  align-self: flex-start;
  align-items: flex-start;
  justify-content: flex-start;
  flex-shrink: 0;
`;

export const IconWrapperModeCommonStyles = css`
  &[data-mode=${HeaderIconMode.AdminActionItem}] {
    background: ${Colour.Clarity.Base.White};
    border: 1px solid ${Colour.Clarity.Grey.ExtraSoft};
    color: ${Colour.Clarity.Content.Hard};

    & path {
      stroke: url(#primaryGradient);
    }
  }

  &[data-mode=${HeaderIconMode.ActionItem}] {
    background: linear-gradient(135deg, #3991ff 0%, #a48afb 50.15%);
    color: ${Colour.Clarity.Base.White};
  }

  &[data-mode=${HeaderIconMode.Timesheet}] {
    background: linear-gradient(135deg, #fa7066 0%, #a48afb 100%);
    color: ${Colour.Clarity.Base.White};
  }

  &[data-mode=${HeaderIconMode.AdminTimesheet}] {
    background: ${Colour.Clarity.Base.White};
    border: 1px solid ${Colour.Clarity.Grey.ExtraSoft};
    color: ${Colour.Clarity.Content.Hard};

    & path {
      stroke: url(#secondaryGradient);
    }
  }

  &[data-mode=${HeaderIconMode.Object}] {
    background: ${Colour.Clarity.Blue.ExtraSoft};
    color: ${Colour.Clarity.Blue.Hard};
  }

  &[data-mode=${HeaderIconMode.Library}] {
    background: ${Colour.Clarity.Purple.ExtraSoft};
    color: ${Colour.Clarity.Purple.Hard};
  }
`;

export const IconCommonStyles = css`
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease-out;

  & > svg {
    transition: all 0.2s ease-out;
  }
`;

export const IconSizeClassNames = {
  size56: 'header-icon--size-56x56',
  size48: 'header-icon--size-48x48',
  size40: 'header-icon--size-40x40',
  size36: 'header-icon--size-36x36',
  size32: 'header-icon--size-32x32',
} as const;

export const IconSizeClassStyles = css`
  &.${IconSizeClassNames.size56} {
    --header-icon-size: 56px;
    --header-icon-radius: 12px;
  }

  &.${IconSizeClassNames.size48} {
    --header-icon-size: 48px;
    --header-icon-radius: 12px;
  }

  &.${IconSizeClassNames.size40} {
    --header-icon-size: 40px;
    --header-icon-radius: 8px;
  }

  &.${IconSizeClassNames.size36} {
    --header-icon-size: 36px;
    --header-icon-radius: 8px;
  }

  &.${IconSizeClassNames.size32} {
    --header-icon-size: 32px;
    --header-icon-radius: 8px;
  }
`;
